import { render } from "./Dismissable.vue?vue&type=template&id=1de743fc"
import script from "./Dismissable.vue?vue&type=script&lang=js"
export * from "./Dismissable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__